import React, {Component} from 'react';
import {Translation} from 'react-i18next';
import {Col, Row} from 'antd';

import DocumentHead from '../../../elements/components/DocumentHead';
import scrollToTop from '../../../elements/lib/scrollToTop';
import Logger from '../../../../../lib/Logger';

class PostSurveyScreen extends Component {

  render() {
    return (
      <Translation>{(t) => 
        <>

          <DocumentHead title={t('content_route_survey')} />

          <Row>
            <Col span={24}>

              <iframe src="https://www.cognitoforms.com/f/RnQXxvDs4Uyff6Y8NCacyg?id=27" frameBorder="0" scrolling="yes" seamless="seamless" height="1777" width="100%" title="Post Survey"></iframe>

            </Col>
          </Row>

        </>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    scrollToTop();

    const script = document.createElement("script");
    script.src = "https://www.cognitoforms.com/scripts/embed.js";
    script.async = true;
    document.body.appendChild(script);
  }
}

export default PostSurveyScreen;

Logger.log('silly', `PostSurveyScreen loaded.`);
